import { getColumnDataWithBlankSpaces, matchInputDataType } from "../utils";
export const findFunction = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns,
) => {
  const ranges = rule.ranges;
  const dateIndices = [];
  const dataRanges = [];
  let startRow = null;
  const exclusive = rule.exclusiveStartDate;
  const datalength = getColumnDataWithBlankSpaces(
    worksheet,
    rule.inputColumn,
    fileSettings.headerRow,
  );
  const headerRow = Number.isFinite(Number(fileSettings?.headerRow))
    ? Number(fileSettings.headerRow)
    : 0;

  let len = datalength.length;

  let matchesFound = 0;
  let { searchType, searchCriteria } = GetFindType(rule.findType, rule);

  for (let i = 0; i < len; i++) {
    const cell = datalength[i];
    if (matchInputDataType(cell, rule)) {
      matchesFound++;

      const actualRowIndex = i + parseFloat(headerRow);
      dateIndices.push(actualRowIndex);
      if (ranges) {
        if (startRow !== null) {
          const rangeStart = exclusive ? startRow + 1 : startRow;
          dataRanges.push([rangeStart, actualRowIndex - 1]);
        }
        startRow = actualRowIndex;
      }
    }
  }
  if (ranges && startRow !== null && startRow <= len + headerRow) {
    const rangeStart = exclusive ? startRow + 1 : startRow;
    dataRanges.push([rangeStart, len + headerRow - 1]);
  }

  return {
    data: ranges ? dataRanges : dateIndices,
    trackingInfo: {
      searchType: searchType,
      searchCriteria: searchCriteria,
      searchValue: rule.searchValue || null,
      matchesFound: matchesFound,
      totalRowsSearched: len,
      outputType: ranges ? "ranges" : "indices",
      rangesCreated: ranges ? dataRanges.length : 0,
      indicesFound: ranges ? 0 : dateIndices.length,
      inputColumn: rule.inputColumn,
      exclusiveMode: exclusive || false,
      headerRowUsed: headerRow,
    },
  };
};

const GetFindType = (type, rule) => {
  let searchType = "unknown";
  let searchCriteria = "N/A";
  switch (type) {
    case "3": // Date
      searchType = "date";
      searchCriteria = "Any valid date format";
      break;
    case "2": // Number
      searchType = "numeric";
      searchCriteria = rule.searchValue || "N/A";
      break;
    case "1": // Text
      searchType = "text";
      searchCriteria = rule.searchValue || "N/A";
      break;
    default:
      searchType = "unknown";
      searchCriteria = "N/A";
      break;
  }
  return { searchType, searchCriteria };
};
